<template>
  <div>
    <AppHeader />
    <div class="articles">
<!--      <DevelopmentSection />-->
      <div
        class="articles__prewiew"
      >

        <v-container
          class="articles__prewiew-inner"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
            >
              <h1 class="articles__prewiew-title">Articles</h1>
            </v-flex>
          </v-layout>
          <div class="articles__search">
            <div class="articles__search-inner">
              <v-text-field
                  v-model="searchArticles"
                  label="Search articles"
                  solo
              />
              <v-btn
                color="teal lighten-2"
                class="articles__search-submit white--text"
              >
                <i class="fas fa-search"></i>
              </v-btn>
            </div>
          </div>
        </v-container>
      </div>
      <v-container v-if="filtredArticles"
        v-bind="{ [`grid-list-xl`]: true }"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
          v-for="article in filtredArticles" :key="article.id"
            xs12 md6
          >
            <v-card
              :to="{ name: 'article', params: { id: article.id }}"
            >
              <v-img
                v-if="article.header_image"
                :src="article.header_image"
                aspect-ratio="2.75"
              ></v-img>
              <v-img 
              v-else
              aspect-ratio="2.75"
              :src="require('../assets/article-background.jpg')"
              >
                
              </v-img>
              <v-card-title>
                <div>
                  <h3 class="mb-0">{{article.title}}</h3>
                  <div v-html="article.content" class="articles__text_preview"></div>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

        </v-layout>
      </v-container>
            <br>
      <br>
      <br>
      <br>
      <br>
      <BottomNavigation />
    </div>
  </div>
</template>

<script>
  import AppHeader from '../components/AppHeader';
  import BottomNavigation from "../components/BottomNavigation";
    import { mapGetters } from "vuex";

  // import DevelopmentSection from '../components/DevelopmentSection';
  export default {
    name: 'Articles',
    components: {
      AppHeader,
      BottomNavigation,
      // DevelopmentSection
    },
    data(){
      return {
        searchArticles: '',
      }
    },
        computed: {
      ...mapGetters(
        'articles', ['getArticles', 'getError'],
        ),
              filtredArticles: function () {
        if(this.searchArticles) {
          return this.getArticles.filter( article => article.title.toLowerCase().search(this.searchArticles.toLowerCase()) != -1  );
        }
        return this.getArticles;
      },
    },
        mounted() {
      this.$store.dispatch('articles/articlesRequest');
    },
  }
</script>

<style scoped>
  .articles__prewiew {
    color: #fff;
    background-color: #212121;
    padding: 30px 0;
    margin-bottom: 45px;
  }

  .articles__prewiew-inner {
    position: relative;
  }

  .articles__search {
    position: absolute;
    bottom: -82px;
    left: 0;
    width: 100%;
    padding: 0 15px;
  }

  .articles__search-inner {
    display: flex;
  }

  .articles__search-submit {
    margin: 0;
    height: 48px;
    position: relative;
    left: -2px;
  }
  .articles__text_preview {
    position: relative;
    word-break:break-word;
    word-wrap:break-word;
}

  .articles__text_preview >>> img {
    display: none;
}

</style>
